module.exports = __webpack_public_path__ + "static/media/merry.2b84c7f2.png";